import { createContext, useContext, useEffect, useState } from "react";
import api from "../lib/api";
import { useAuth } from "./AuthContext";

const PosContext = createContext(null);

export function PosProvider({ children }) {
  const { user } = useAuth();
  const [posList, setPosList] = useState([]);
  const [selectedPos, setSelectedPos] = useState("all");

  useEffect(() => {
    if (!user) return;
    api.get("/pos").then(({ data }) => setPosList(data)).catch(() => {});
    if (user.role !== "admin" && user.pos_id) setSelectedPos(user.pos_id);
    else setSelectedPos("all");
  }, [user]);

  const isAdmin = user?.role === "admin";
  const labPos = posList.find((p) => p.type === "laboratoire");
  const labPosId = labPos?.id || null;
  const labPosName = labPos?.nom || "Laboratoire TIRAMESSI";
  // Points de vente affichés dans les sélecteurs : boutiques/stands actifs uniquement.
  // Le laboratoire et la distribution B2B ne sont jamais des points de vente sélectionnables.
  const salesPosList = posList.filter((p) => p.type !== "laboratoire" && p.type !== "distribution" && p.actif !== false);
  // POS à utiliser lors des écritures (ventes, dépenses...)
  const writePosId = isAdmin ? (selectedPos !== "all" ? selectedPos : null) : user?.pos_id;
  const selectedPosName =
    selectedPos === "all" ? "Tous les points de vente" : posList.find((p) => p.id === selectedPos)?.nom || "";

  return (
    <PosContext.Provider value={{ posList, salesPosList, selectedPos, setSelectedPos, writePosId, isAdmin, selectedPosName, labPosId, labPosName }}>
      {children}
    </PosContext.Provider>
  );
}

export const usePos = () => useContext(PosContext) || { selectedPos: "all", posList: [], salesPosList: [], writePosId: null, isAdmin: false, labPosId: null, labPosName: "Laboratoire TIRAMESSI" };
